<template lang="pug">
  app-modal.modalAvocar(
    titulo="Atenção",
    @closeModal="closeModal",
    :width="550"
    :headerStyle="{ backgroundColor: '#ffffff'}",
    :titleStyle="{ color: '#000000 !important', fontWeight: 'normal' }"
  )
    template(slot="body")
      span.titulo
        span.icone
          i.fas.fa-exclamation-circle(style="color: #ed8e07;")
        span &nbsp Tem certeza que deseja regerar o(s) processo(s) selecionado(s)?
    template(slot="footer")
      .flex
        el-button.btn(
            :id="'cancelarAvocar'",
            type="default",
            size="small",
            @click="closeModal()"
          )
            span.center
              i.el-icon.fas.fa-times
              b &nbsp Cancelar
        el-button.btn(
          :id="'confirmarAvocar'",
          type="success",
          size="small",
          @click="finalizar"
        )
          span.center
            i.el-icon.fas.fa-check
            b &nbsp Confirmar

</template>
<script>
import AppModal from '@/components/AppModal'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {
  components: {
    AppModal,
    AppEditorTexto
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      texto: ''
    }
  },

  props: {
    idsProcessos: {
      required: true
    }
  },

  methods: {
    ...mapActions({
      regerar: 'filaAnaliseAutomatizada/regerar'
    }),

    closeModal () {
      this.$emit('closeModal')
      window.location.reload()
    },

    async finalizar () {
      await this.regerar(this.idsProcessos)
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) enviados para a Fila')
      this.$router.push({
        name: 'EM_ANALISE'
      })
      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.flex {
  margin-top: 5px;
  display: flex;
  justify-content:right;
}

.titulo {
  display: flex;
  justify-content: left;
  font-size:14px;
  color: #211b15;
}

.required {
  color: #b22222;
}

.cor-warning {
  color: hsl(32, 100%, 50%);
}
.icone {
  font-size: 30px;
  margin-top: -10px;
}

@media (max-width: 780px) {
  .modalAvocar {
    position: fixed !important;
    width: 395px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalRegerar.vue